import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../index.css';

const GrapeContractDetail = () => {
    const { contractID } = useParams(); // `contractID` may be undefined for new contracts
    const navigate = useNavigate();
    const [contract, setContract] = useState({
        growerID: '',
        year: new Date().getFullYear(),
    });
    const [entries, setEntries] = useState([]);
    const [newEntry, setNewEntry] = useState({ vineyardID: '', pricePerTon: 0 });
    const [error, setError] = useState(null);

    useEffect(() => {
        if (contractID) {
            fetchContractDetails();
        }
    }, [contractID]);

    const fetchContractDetails = async () => {
        try {
            const res = await axios.get(`/api/grape-contracts/${contractID}`);
            setContract(res.data.contract);
            setEntries(res.data.entries);
        } catch (err) {
            console.error('Error fetching contract details:', err);
            setError('Failed to load contract details');
        }
    };

    const handleSaveContract = async () => {
        try {
            if (contractID) {
                // Update existing contract
                await axios.put(`/api/grape-contracts/${contractID}`, contract);
            } else {
                // Create new contract
                const res = await axios.post('/api/grape-contracts', contract);
                navigate(`/grape-contracts/${res.data.contractID}`);
            }
        } catch (err) {
            console.error('Error saving contract:', err);
            setError('Failed to save contract.');
        }
    };

    const handleAddEntry = async () => {
        try {
            if (!contractID) {
                return alert('Please save the contract before adding entries.');
            }
            const res = await axios.post(`/api/grape-contracts/${contractID}/entries`, newEntry);
            setEntries([...entries, res.data]);
            setNewEntry({ vineyardID: '', pricePerTon: 0 });
        } catch (err) {
            console.error('Error adding entry:', err);
            setError('Failed to add entry.');
        }
    };

    return (
        <div className="container mt-4">
            <h3>{contractID ? `Edit Grape Contract: ${contract.year}` : 'New Grape Contract'}</h3>
            <button onClick={() => navigate('/grape-contracts')} className="btn btn-secondary mb-3">
                Back to Contracts
            </button>
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
                <label>Grower</label>
                <input
                    type="text"
                    className="form-control"
                    value={contract.growerID}
                    onChange={(e) => setContract({ ...contract, growerID: e.target.value })}
                />
            </div>
            <div className="mb-3">
                <label>Year</label>
                <input
                    type="number"
                    className="form-control"
                    value={contract.year}
                    onChange={(e) => setContract({ ...contract, year: parseInt(e.target.value, 10) })}
                />
            </div>
            <button onClick={handleSaveContract} className="btn btn-primary mb-3">
                {contractID ? 'Save Changes' : 'Create Contract'}
            </button>

            {contractID && (
                <>
                    <div>
                        <h4>Entries</h4>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Vineyard</th>
                                    <th>Price/Ton</th>
                                    <th>Payout</th>
                                </tr>
                            </thead>
                            <tbody>
                                {entries.map((entry) => (
                                    <tr key={entry.id}>
                                        <td>{entry.vineyardName}</td>
                                        <td>${entry.pricePerTon.toFixed(2)}</td>
                                        <td>${entry.totalPayout.toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <h4>Add Entry</h4>
                        <select
                            value={newEntry.vineyardID}
                            onChange={(e) => setNewEntry({ ...newEntry, vineyardID: e.target.value })}
                            className="form-control mb-2"
                        >
                            <option value="">Select Vineyard</option>
                            {/* Populate dynamically */}
                        </select>
                        <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="Price per ton"
                            value={newEntry.pricePerTon}
                            onChange={(e) => setNewEntry({ ...newEntry, pricePerTon: parseFloat(e.target.value) })}
                        />
                        <button onClick={handleAddEntry} className="btn btn-primary">
                            Add Entry
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default GrapeContractDetail;